/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitGuidelineExtensionEnum } from './PressKitGuidelineExtensionEnum';
import {
    PressKitGuidelineExtensionEnumFromJSON,
    PressKitGuidelineExtensionEnumFromJSONTyped,
    PressKitGuidelineExtensionEnumToJSON,
} from './PressKitGuidelineExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import type { PressKitThumbnailUrls } from './PressKitThumbnailUrls';
import {
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキットガイドラインのファイル
 * @export
 * @interface PressKitGuidelineFile
 */
export interface PressKitGuidelineFile {
    /**
     * PressKit Guideline File UUID(v4)
     * @type {string}
     * @memberof PressKitGuidelineFile
     */
    id: string;
    /**
     * ファイルリソースが保存されたS3のURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PressKitGuidelineFile
     */
    resourceUri: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitGuidelineFile
     */
    title: string;
    /**
     * 
     * @type {PressKitGuidelineExtensionEnum}
     * @memberof PressKitGuidelineFile
     */
    extension: PressKitGuidelineExtensionEnum;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitGuidelineFile
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * ガイドラインのファイルへ直接アクセスできるURL
     * @type {string}
     * @memberof PressKitGuidelineFile
     */
    downloadUrl: string;
    /**
     * 企業が登録したファイルの名前（title+extension）
     * @type {string}
     * @memberof PressKitGuidelineFile
     */
    filename: string;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitGuidelineFile
     */
    fileSize: number;
    /**
     * サムネイル画像が保存されたS3へのURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PressKitGuidelineFile
     */
    thumbnailUri: string;
    /**
     * 設定されているタグ一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitGuidelineFile
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PressKitGuidelineFile interface.
 */
export function instanceOfPressKitGuidelineFile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "resourceUri" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "thumbnailUrls" in value;
    isInstance = isInstance && "downloadUrl" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "thumbnailUri" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PressKitGuidelineFileFromJSON(json: any): PressKitGuidelineFile {
    return PressKitGuidelineFileFromJSONTyped(json, false);
}

export function PressKitGuidelineFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitGuidelineFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'resourceUri': json['resource_uri'],
        'title': json['title'],
        'extension': PressKitGuidelineExtensionEnumFromJSON(json['extension']),
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'filename': json['filename'],
        'fileSize': json['file_size'],
        'thumbnailUri': json['thumbnail_uri'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitGuidelineFileToJSON(value?: PressKitGuidelineFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'resource_uri': value.resourceUri,
        'title': value.title,
        'extension': PressKitGuidelineExtensionEnumToJSON(value.extension),
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
        'filename': value.filename,
        'file_size': value.fileSize,
        'thumbnail_uri': value.thumbnailUri,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

